// extracted by mini-css-extract-plugin
module.exports = {"select":"LocationSelect_select__2lgOC"};